import React from 'react';

/**
 * Dasha Timeline — horizontal bar showing all 9 Mahadashas from birth.
 * Current MD highlighted with Gold glow.
 *
 * Props:
 *   - timeline: vimshottari.timeline array
 *   - onClickMD: (mdObj) => void
 */

const LORD_COLOR = {
  Ketu: '#f472b6', Venus: '#f9a8d4', Sun: '#fbbf24', Moon: '#e5e7eb',
  Mars: '#f87171', Rahu: '#a78bfa', Jupiter: '#fcd34d',
  Saturn: '#94a3b8', Mercury: '#86efac',
};

export default function DashaTimeline({ timeline = [], onClickMD }) {
  if (!timeline || timeline.length === 0) return null;
  const totalYears = timeline.reduce((s, t) => s + t.years, 0);

  return (
    <div data-testid="dasha-timeline" className="space-y-3">
      <div className="text-xs text-text-muted">
        जन्म से 120 वर्षों तक की महादशा रेखा — वर्तमान महादशा पर सुनहरी चमक · क्लिक करें विवरण के लिए
      </div>

      {/* Bar (proportional width) */}
      <div className="hidden sm:flex w-full rounded-xl overflow-hidden border border-gold/30 bg-bg-primary/40" style={{ height: 56 }}>
        {timeline.map((t, i) => {
          const widthPct = (t.years / totalYears) * 100;
          const color = LORD_COLOR[t.lord_en] || '#FFD700';
          return (
            <button
              key={`tl-${i}`}
              data-testid={`timeline-md-${t.lord_en}`}
              onClick={() => onClickMD && onClickMD(t)}
              title={`${t.lord_hi} · ${t.start_year}–${t.end_year} · ${t.years.toFixed(1)} वर्ष`}
              className="relative group h-full transition-all hover:brightness-125 first:rounded-l-xl last:rounded-r-xl"
              style={{
                width: `${widthPct}%`,
                backgroundColor: color + '40',
                borderRight: '1px solid rgba(255,215,0,0.25)',
                boxShadow: t.is_current ? `inset 0 0 0 2px ${color}, 0 0 14px ${color}cc` : undefined,
              }}
            >
              <div className="flex flex-col items-center justify-center h-full px-1">
                <span className="text-[10px] font-bold" style={{ color }}>{t.lord_hi}</span>
                <span className="text-[9px] text-white/70 mt-0.5">{t.start_year}–{t.end_year}</span>
                {t.is_current && <span className="absolute top-0 right-1 text-[8px] text-gold font-bold">●</span>}
              </div>
            </button>
          );
        })}
      </div>

      {/* Mobile vertical list */}
      <div className="sm:hidden space-y-1.5">
        {timeline.map((t, i) => (
          <button
            key={`tlm-${i}`}
            onClick={() => onClickMD && onClickMD(t)}
            className={`w-full flex items-center justify-between rounded-lg border px-3 py-2 ${t.is_current ? 'bg-gold/15 border-gold/60 shadow-md shadow-gold/20' : 'bg-white/5 border-white/10'}`}
          >
            <span className="font-heading" style={{ color: LORD_COLOR[t.lord_en] || '#FFD700' }}>{t.lord_hi}</span>
            <span className="text-xs text-text-muted">{t.start_year} – {t.end_year} · {t.years.toFixed(1)}Y</span>
          </button>
        ))}
      </div>
    </div>
  );
}
